/**
 * 邀请链接对话框组件
 */

import { useState } from 'react'
import {
  Button,
  Input,
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
} from '@you/ui'
import { Check } from 'lucide-react'

interface InviteLinkDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  inviteUrl?: string
  onCopy: (url: string) => Promise<void>
}

export const InviteLinkDialog = ({
  open,
  onOpenChange,
  inviteUrl,
  onCopy,
}: InviteLinkDialogProps) => {
  const [copySuccess, setCopySuccess] = useState(false)

  const handleCopy = async () => {
    if (inviteUrl) {
      await onCopy(inviteUrl)
      setCopySuccess(true)
      setTimeout(() => setCopySuccess(false), 2000) // 2秒后重置状态
    }
  }

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      setCopySuccess(false) // 关闭对话框时重置复制状态
    }
    onOpenChange(open)
  }

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent>
        <DialogHeader title="邀请成员" />
        <div className="px-6 py-4">
          <div className="mb-4">
            <label className="block text-sm font-medium mb-2">邀请链接</label>
            <Input
              value={inviteUrl || ''}
              readOnly
              placeholder="生成邀请链接中..."
            />
          </div>
        </div>
        <DialogFooter>
          <Button
            onClick={handleCopy}
            disabled={!inviteUrl}
            className={copySuccess ? 'bg-green-600 hover:bg-green-700' : ''}
          >
            {copySuccess ? (
              <>
                复制成功 <Check className="w-4 h-4 ml-1" />
              </>
            ) : (
              '复制到剪切板'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
